export default "__VITE_ASSET__BDEoKTD$__"